import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Port_01 from '../../../assets/images/portfolio/portfolio-three-1.jpg';
import Port_02 from '../../../assets/images/portfolio/portfolio-three-2.jpg';
import Port_03 from '../../../assets/images/portfolio/portfolio-three-3.jpg';
import Port_04 from '../../../assets/images/portfolio/portfolio-three-4.jpg';
import Port_arrowright from '../../../assets/images/portfolio/Aerrow-right.svg';
import Port_starshape from '../../../assets/images/portfolio/portfolio-star-shape.svg';



const port = {
    arrows: false,
    slidesToShow: 3,
    cssEase: 'linear',
    slidesToScroll: 1,
    autoplay: true,
    Infinity: true,
    autoplaySpeed: 0,
    speed: 5000

}
const Portfilo = () => {

    return (
        <>
            <div className="portfolio-section-three">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box light text-center">
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Have a view of our amazing projects with our clients
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio-three">
                        <div className="portfolio-box-three">
                            <div className="portfolio-image-three">
                                <img
                                    src={Port_01}
                                    alt="portfolio-image"
                                />
                            </div>
                            <div className="portfolio-details-three">
                                <div className="portfolio-title-three">
                                    <h4>Bank Credit Collection System</h4>
                                    <p>Corporate - Business Collection</p>
                                </div>
                                <Link to="/Details" className="portfolio-btn-three">
                                    <img src={Port_arrowright} alt="icon" />
                                </Link>
                            </div>
                        </div>
                        <div className="portfolio-box-three">
                            <div className="portfolio-image-three">
                                <img
                                    src={Port_02}
                                    alt="portfolio-image"
                                />
                            </div>
                            <div className="portfolio-details-three">
                                <div className="portfolio-title-three">
                                    <h4>Credit Risk Assessment</h4>
                                    <p>Banking - Finance</p>
                                </div>
                                <Link to="/Details" className="portfolio-btn-three">
                                    <img src={Port_arrowright} alt="icon" />
                                </Link>
                            </div>
                        </div>
                        <div className="portfolio-box-three">
                            <div className="portfolio-image-three">
                                <img
                                    src={Port_03}
                                    alt="portfolio-image"
                                />
                            </div>
                            <div className="portfolio-details-three">
                                <div className="portfolio-title-three">
                                    <h4>Automated Payment Reminders</h4>
                                    <p>Technology - Business Automation</p>
                                </div>
                                <Link to="/Details" className="portfolio-btn-three">
                                    <img src={Port_arrowright} alt="icon" />
                                </Link>
                            </div>
                        </div>
                        <div className="portfolio-box-three">
                            <div className="portfolio-image-three">
                                <img
                                    src={Port_04}
                                    alt="portfolio-image"
                                />
                            </div>
                            <div className="portfolio-details-three">
                                <div className="portfolio-title-three">
                                    <h4>Collection Strategy Implementation</h4>
                                    <p>Debt Recovery - Corporate</p>
                                </div>
                                <Link to="/Details" className="portfolio-btn-three">
                                    <img src={Port_arrowright} alt="icon" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-30">
                        <div className="col-lg-4">
                            <div
                                className="portfolio-left-three animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="heading-box light">
                                    <h2 className="heading-title">
                                        Customers are served behind the digital marketing
                                    </h2>
                                </div>
                                <p className="lead">
                                    Uniqo offers full range of consultancy &amp; training for data
                                    consultation strategic ways for business.
                                </p>
                                <Link to="/Aboutus" className="btn btn-light btn-theme">
                                    View More <span>+</span>
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="portfolio-right-three">
                                <div className="row gutter-y-20">
                                    <div
                                        className="col-lg-4 col-md-4 portfolio__three_box animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        <div className="portfolio-box-three-1">
                                            <div className="portfolio-box-three-1-inner" >
                                                <div
                                                    className="circleGraphic"
                                                    data-circle-options="{
                                            &quot;color&quot;: &quot;#C9A885&quot;,
                                            &quot;value&quot;: 45,
                                            &quot;thickness&quot;: 4
                                          }"
                                                />
                                                <span>45%</span>
                                                <CircularProgressbar
                                                    value={45}
                                                    styles={buildStyles({
                                                        pathColor: '#C9A885',
                                                        textColor: '#000',
                                                        trailColor: '#d6d6d6',
                                                    })}
                                                />
                                            </div>
                                            <h4>Business Development</h4>
                                            <p>
                                                Consulting services give experienced levels of expertise .
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className="col-lg-4 col-md-4 portfolio__three_box animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="400ms"
                                    >
                                        <div className="portfolio-box-three-1">
                                            <div className="portfolio-box-three-1-inner">
                                                <div
                                                    className="circleGraphic"
                                                    data-circle-options="{
                                            &quot;color&quot;: &quot;#C9A885&quot;,
                                            &quot;value&quot;: 65,
                                            &quot;thickness&quot;: 4
                                          }"

                                                />
                                                <span>65%</span>
                                                <CircularProgressbar
                                                    value={65}
                                                    styles={buildStyles({
                                                        pathColor: '#C9A885',
                                                        textColor: '#000',
                                                        trailColor: '#d6d6d6',
                                                    })}
                                                />
                                            </div>
                                            <h4>Financial Reporting</h4>
                                            <p>
                                                Results driven marketing campaigns are deployed to achieve
                                                objectives.&nbsp;
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className="col-lg-4 col-md-4 portfolio__three_box animate fadeInRight wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="600ms"
                                    >
                                        <div className="portfolio-box-three-1">
                                            <div className="portfolio-box-three-1-inner">
                                                <div
                                                    className="circleGraphic"
                                                    data-circle-options="{
                                            &quot;color&quot;: &quot;#C9A885&quot;,
                                            &quot;value&quot;: 85,
                                            &quot;thickness&quot;: 4
                                          }"

                                                />
                                                <span>85%</span>
                                                <CircularProgressbar
                                                    value={85}
                                                    styles={buildStyles({
                                                        pathColor: '#C9A885',
                                                        textColor: '#000',
                                                        trailColor: '#d6d6d6',
                                                    })}
                                                />
                                            </div>
                                            <h4>Investment Analysis</h4>
                                            <p>
                                                Quality and experienced design &amp; development services
                                                manage.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Slider {...port} className="portfolio-slider-three" slidesToShow={2}> 
                    <div className="portfolio-item-three">
                        <h5>Business</h5>
                        <img src={Port_starshape} alt="icon" />
                    </div>
                    <div className="portfolio-item-three">
                        <h5>Finance</h5>
                        <img src={Port_starshape} alt="icon" />
                    </div>
                    <div className="portfolio-item-three">
                        <h5>Branding</h5>
                        <img src={Port_starshape} alt="icon" />
                    </div>
                    <div className="portfolio-item-three">
                        <h5>Business</h5>
                        <img src={Port_starshape} alt="icon" />
                    </div>
                </Slider>
            </div>

        </>
    )
}

export default Portfilo
